import store from 'store'

export function money (quantity, currency = store.state.i18n.currency, minimumFractionDigits = 2) {
  const formatter = new Intl.NumberFormat(store.state.i18n.locale, {
    style: 'currency',
    currency,
    minimumFractionDigits
  })

  return formatter.format(quantity / 100)
}
